import Request from '../Request.utils'
export interface ISubscribeNewsletterRequestBody {
  email: string;
  source?: string;
}


class NewsletterAPI {
  subscribeNewsletter = async (body: ISubscribeNewsletterRequestBody) => {
    const res = await Request.call('/api/newsletter/subscribe', 'POST', undefined, undefined, body, );
    return res;
  }
}
export default new NewsletterAPI()